import { View } from "binder"
import { UnitEditorViewModel } from "./unitEditor-viewModel"

export class UnitEditorView extends View<UnitEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-0A16CEE0-86E4-450B-8FE9-9FB9A20F0D34"
    }
    loadHtml(): string {
        let element = require('./unitEditor.html').default;
        let style = require('./unitEditor.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set symbol(v: string) { this._symbol = v; } public get symbol(): string { return this._symbol;} private _symbol: string;
    
    back(){
        this.dataContext.back();
    }

    save(){
        this.dataContext.save();
    }
}
